
const state = {
  description: '',
  id: null,
  owner_id: undefined,
  owner_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
